/**
 * Provider for "IP" property
 * @module
 */
var GeoSource = require('core/plugins/sources/geo');

module.exports = {
  // Source returns a deferred
  isAsync: true,
  provides: 'IP',
  getter: [
    function() {
      return GeoSource.getIP();
    }
  ],
};
